<template>
  <q-page class="docs-table" :style-fn="myTweak">
    <q-table
        :title="$t('notifications.menu.list')"
        ref="table"
        :data="serverData"
        :columns="columns"
        :filter="filter"
        row-key="id"
        :pagination.sync="serverPagination"
        :visible-columns="visibleColumns"
        :loading="loading"
        :selection="selection"
        :selected.sync="selectedRows"
        class="card-shadow"
        @request="all"
    >
      <template v-slot:top-selection="props" v-if="$auth.can('notifications.edit')">
        <q-btn color="negative" outline icon="fa fa-trash" :label="$t('delete')" class="q-mr-sm" @click="deleteRows"/>
        <q-btn color="pink-5" outline icon="fa fa-times" class="q-mr-sm" @click="selectedRows = []"/>
      </template>

      <template v-slot:top-right="props">
      	<q-btn outline :label="$t('refresh')" icon="fas fa-sync" color="input-color" class="q-mr-sm" @click="all({pagination: serverPagination, filter})" :loading="loading">
			<template v-slot:loading>
		    <q-spinner-dots />
		  </template>
		</q-btn>
        <q-input dense debounce="300" v-model="filter" :placeholder="$t('search')" class="q-mr-sm">
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
        </q-input>
        <q-select
            v-model="visibleColumns"
            multiple
            dense
            options-dense
            :display-value="$q.lang.table.columns"
            emit-value
            map-options
            :options="columns"
            option-value="name"
            style="min-width: 150px;margin-right:10px"
            color="input-color"
        />
      </template>

      <!-- START CUSTOM COLUMNS -->
      <q-td slot="body-cell-user" slot-scope="props" :props="props">
          {{props.row.user.name}}
          <q-btn icon="fa fa-link" size="xs" color="info" round flat @click="$router.push('/users?q='+props.row.user.email)" v-if="$auth.can('users.list')"/>
      </q-td>

      <q-td slot="body-cell-data" slot-scope="props" :props="props">
          {{props.row.data.length ? props.row.data : '-'}}
      </q-td>

      <q-td slot="body-cell-setting" slot-scope="props" :props="props" v-if="$auth.can('notifications.edit')">
        <q-btn round size="sm" color="red" icon="fa fa-trash" @click="deleteRow(props.row)"/>
      </q-td>
      <!-- END CUSTOM COLUMNS -->
    </q-table>
  </q-page>
</template>

<script>
  import Notification from '../models/Notification.js'
  export default {
    name: 'NotificationList',
    props: {
        user: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
	  columns() {
        let columns = [
          {name: 'id', required: true, label: this.$t('notifications.table_titles.id'), align: 'left', field: 'id', sortable: true},
          {name: 'user', label: this.$t('notifications.table_titles.user'), align: 'left', field: 'user.name', sortable: false},
          {name: 'type', label: this.$t('notifications.table_titles.type'), align: 'left', field: 'type', sortable: true},
          {name: 'data', label: this.$t('notifications.table_titles.data'), align: 'left', field: 'data', sortable: false},
          {name: 'created_at', label: this.$t('notifications.table_titles.created_at'), align: 'left', field: 'created_at', sortable: true},
          {name: 'read_at', label: this.$t('notifications.table_titles.read_at'), align: 'left', field: 'read_at', sortable: false},
        ]

        // add Edit/Delete column just if the user has appropriate permission
        if(this.$auth.can('notifications.edit')){
          this.selection = 'multiple'
          this.visibleColumns.push('setting')
          columns.push({name: 'setting', align: 'center', label: this.$t('notifications.table_titles.setting'), sortable: false, field: 'setting'})
        }
        return columns;
      },
    },
    data: () => ({
      separator: 'horizontal',
      filter: '',
      loading: false,
      serverPagination: {
        page: 1,
        sortBy: 'created_at',
        rowsPerPage: 15,
        descending: true,
        rowsNumber: 10 // specifying this determines pagination is server-side
      },
      visibleColumns: ['id', 'user', 'type', 'created_at', 'read_at'],
      serverData: [],
      selection: 'none',
      selectedRows: []
    }),
    methods: {
      all({pagination, filter}) {
        this.loading = true
        Notification.all(`${this.user.id ? `user_id=${this.user.id}&` : ''}sort=${pagination.sortBy}%7C${pagination.descending ? 'desc' : 'asc'}&page=${pagination.page}&per_page=${pagination.rowsPerPage}&filter=${filter}`, ({data, meta}) => {
          this.serverPagination = pagination
          // we also set (or update) rowsNumber
          this.serverPagination.rowsNumber = meta.total
          this.serverData = data
          this.loading = false
        }).catch(error => {
          this.$q.notify({
            message: error.data.error,
            color: 'negative',
            icon: 'fa fa-exclamation-triangle'
          })
          this.loading = false
        })
      },
      edit(value) {
        this.$router.push({name: 'notifications.edit', params: {id: value.id}})
      },
      deleteRow(row) {
        this.selectedRows.push(row);
        this.deleteRows();
      },
      deleteRows() {
        this.$q.dialog({
          title: 'Delete information',
          message: 'Are your sure?',
          ok: 'Yes',
          cancel: 'No'
        }).onOk(() => {
          this.$q.loading.show()
          this.selectedRows.map((row) => {
            let notification = new Notification({id: row.id});
            notification.destroy(() => {
              this.serverData = this.serverData.filter(record => record.id !== row.id);
              this.selectedRows = this.selectedRows.filter(member => member.id !== row.id);
              if(!this.selectedRows.length){
                this.$q.loading.hide()
              }
            }).catch(({data}) => {
              this.$q.notify(data.error)
              this.$q.loading.hide()
            })
          });
        }).onCancel(() => {
          this.$q.loading.hide()
        })
      },
      myTweak (offset) {
        return { minHeight: offset ? `calc(35vh - ${offset}px)` : '35vh' }
      },
    },
    beforeCreate() {
      if(! this.$auth.can('notifications.list')){
        this.$router.push({name: 'dashboard'})
      }
    },
    mounted() {
      // once mounted, we need to trigger the initial server data fetch
      this.all({
        pagination: this.serverPagination,
        filter: this.filter
      })
    },
    components: {}
  }
</script>
